<template>
	<div id="app" :class="{ 'is-meet': $route.name === 'embedded-meet' }">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	name: "steps-layout",
	data() {
		return {};
	},
	mounted() {},
	computed: {
		...mapGetters({}),
	},
	methods: {
		...mapActions({}),
	},
};
</script>

<style lang="scss">
@import "@/assets/scss/variables";

#app {
	display: flex;
	height: 100%;
	flex-direction: column;

	&.is-meet {
		overflow: hidden;
	}
}
</style>
